import React, { useEffect, useState } from "react"
import AlertFixo from "@material-ui/lab/Alert"
import Button from "@material-ui/core/Button"
import IconButton from "@material-ui/core/IconButton"
import Collapse from "@material-ui/core/Collapse"
import CloseIcon from "@material-ui/icons/Close"
import Dialog from "@material-ui/core/Dialog"
import DialogTitle from "@material-ui/core/DialogTitle"
import DialogContent from "@material-ui/core/DialogContent"
import DialogActions from "@material-ui/core/DialogActions"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import Checkbox from "@material-ui/core/Checkbox"
import { useSnackbar } from "../../utils/notificacoes"

import {
    buscarStatusQuitacao,
    habilitarQuitacao,
    getIdEstabelecimentoAtual,
} from "../../services/quitacaoAutomatica"

/**
 * Barra fixa no topo (global) que oferece a ativação da quitação automática via Pix
 * para o lojista bloqueado por inadimplência. Espelha o fluxo do componente
 * FaixaQuitacao do sistemaadm: ler termos + aceite + ativar. O lojista pode ignorar
 * a barra por 24h (cookie). Montada uma vez em routes.js, após <DivulgacoesPainel/>.
 */
export default function BannerQuitacao() {
    const { enqueueSnackbar } = useSnackbar()

    const auth = localStorage.getItem("chaveSistema")
    const idEstab = getIdEstabelecimentoAtual()

    const [status, setStatus] = useState(null)
    const [aberto, setAberto] = useState(false) // barra visível
    const [modalTermos, setModalTermos] = useState(false)
    const [aceite, setAceite] = useState(false)
    const [enviando, setEnviando] = useState(false)

    const cookieDismiss = idEstab ? `quitacaoBannerDismiss_${idEstab}` : null

    const carregarStatus = () => {
        if (!auth || !idEstab) return
        buscarStatusQuitacao(auth, idEstab).then(dados => {
            if (!dados) return
            setStatus(dados)
            if (dados.elegivel && !dados.modoAtivo && !window.getCookie(cookieDismiss)) {
                setAberto(true)
            } else {
                setAberto(false)
            }
        })
    }

    useEffect(() => {
        carregarStatus()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const ignorar24h = () => {
        setAberto(false)
        if (cookieDismiss) window.setCookie(cookieDismiss, "true", 1)
    }

    const ativar = async () => {
        setEnviando(true)
        const retorno = await habilitarQuitacao(auth, idEstab)
        setEnviando(false)
        const variant =
            retorno?.result === "success"
                ? "success"
                : retorno?.result === "alert"
                ? "warning"
                : "error"
        enqueueSnackbar(retorno?.message || "Não foi possível ativar.", { variant })
        if (retorno?.result === "success") {
            setModalTermos(false)
            setAberto(false)
            carregarStatus()
        }
    }

    if (!auth || !idEstab) return null

    return (
        <>
            <Collapse
                in={aberto}
                style={{
                    position: "fixed",
                    top: "0",
                    left: "0",
                    zIndex: "1399",
                    width: "100%",
                }}
            >
                <AlertFixo
                    severity="warning"
                    action={
                        <>
                            <Button
                                color="primary"
                                variant="contained"
                                size="small"
                                onClick={() => setModalTermos(true)}
                            >
                                Ler termos e ativar
                            </Button>
                            <IconButton
                                aria-label="ignorar"
                                color="inherit"
                                size="small"
                                style={{ marginLeft: "0.5em" }}
                                onClick={ignorar24h}
                            >
                                <CloseIcon fontSize="inherit" />
                            </IconButton>
                        </>
                    }
                >
                    <b>Sua conta está bloqueada por inadimplência.</b> Ative a quitação automática
                    via Pix e deixe suas próximas vendas abaterem o débito.
                </AlertFixo>
            </Collapse>

            <Dialog
                open={modalTermos}
                onClose={() => setModalTermos(false)}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle>Conta bloqueada por inadimplência</DialogTitle>
                <DialogContent dividers>
                    <p style={{ whiteSpace: "pre-line" }}>{status?.termo}</p>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={aceite}
                                onChange={e => setAceite(e.target.checked)}
                                color="primary"
                            />
                        }
                        label="Li e concordo com os termos acima."
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setModalTermos(false)} color="default">
                        Cancelar
                    </Button>
                    <Button
                        onClick={ativar}
                        color="primary"
                        variant="contained"
                        disabled={!aceite || enviando}
                    >
                        Ativar quitação automática
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}
